/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { useReactiveVar } from '@apollo/client';
import * as React from 'react';

import {
    blockMainActionVar,
    CreateTemplateInstanceWizardSteps,
    currentMaxStepVar,
    currentStepVar,
} from '../../../apollo/reactiveVariables/TemplateInstanceVariables';
import { PanelRegion, PanelType, ScenarioName, StatusName, StepName, SubWorkLoad } from '../../../logger';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { CreateTemplateInstanceSidebarComponent } from './CreateTemplateInstanceSidebar.component';

export const CreateTemplateInstanceSidebarContainer: React.FC = (): JSX.Element => {
    const logger = getAppHost().getLogger();
    const currentStep = useReactiveVar(currentStepVar);
    const currentMaxStep = useReactiveVar(currentMaxStepVar);
    const isCurrentPageError = useReactiveVar(blockMainActionVar);

    const onStepClick = (step: CreateTemplateInstanceWizardSteps): void => {
        logger.markScenario(ScenarioName.CreateTemplateInstance, StepName.SideBarSelected, StatusName.NA);
        logger.logUserBiAction(
            SubWorkLoad.AppInteraction,
            ScenarioName.CreateTemplateInstance,
            StepName.SideBarSelected,
            'click',
            'nav',
            'wizardStep',
            'wizardStepButton',
            PanelRegion.Main,
            PanelType.TemplateManagement,
            {
                targetStep: step,
            }
        );

        currentStepVar(step);
    };

    const enabledSteps = new Set<CreateTemplateInstanceWizardSteps>();

    if (isCurrentPageError) {
        enabledSteps.add(currentStep);
    } else {
        for (let step = 1; step <= currentMaxStep; step++) {
            enabledSteps.add(step);
        }
    }

    const componentProps = {
        currentStep,
        enabledSteps,
        onStepClick,
    };

    return <CreateTemplateInstanceSidebarComponent {...componentProps} />;
};
